// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.login-layout .logo-text {\r\n  font-size: 24px;\r\n  font-weight: bold;\n}\n.support-icon {\r\n  position: absolute;\r\n  top:40px;\r\n  right: 40px;\r\n  font-size: 15px;\n}\n.support-icon a{\r\n  text-decoration: none !important;\r\n  color: #fff !important;\n}\n.support-icon .v-icon.mdi-help-circle{\r\n  color: #fff !important;\n}\n.support-icon .text-help{\r\n  margin-top: 5px;\n}\r\n", ""]);
// Exports
module.exports = exports;
